let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gdXTv")).then(() => parcelRequire('31yub'));